import { useBackToQuotesSearchPage } from '@app/components/pages/account/hooks';
import { deletePendingQuote } from '@app/store/account/actions';
import { setError } from '@app/store/exception/actions';
import { replaceTokensInString } from '@app/utils';
import { ToastContext } from 'cat-ecommerce-alloy';
import { useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

const useDeletePendingQuote = isOfflineQuote => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const toastContext = useContext(ToastContext);
  const { goBackToQuotesSearchPage } = useBackToQuotesSearchPage();
  const deleteQuote = useCallback(
    (
      item = {},
      errorDomain = '',
      errorPath = '',
      redirectToPendingQuotes = false
    ) => {
      const toastMessage = replaceTokensInString(
        t('PENDING_QUOTE_DELETE_SUCCESS'),
        item.quoteDocumentNumber || item.orderId
      );
      return (
        dispatch(
          deletePendingQuote(item, isOfflineQuote, toastContext, toastMessage)
        )
          .then(() => {
            if (redirectToPendingQuotes) {
              goBackToQuotesSearchPage();
            }
          })
          .catch(() => {
            const errorMessage = {
              title: t('PENDING_QUOTE_DELETE_ERROR2'),
              message: replaceTokensInString(
                t('PENDING_QUOTE_DELETE_ERROR'),
                item.quoteDocumentNumber
              )
            };
            dispatch(setError(errorDomain, errorPath, errorMessage));
          }),
        [dispatch, t, toastContext]
      );
    }
  );
  return { deleteQuote };
};

export default useDeletePendingQuote;
